import { addToCartPublisher } from "@/utils/storage/extra/loaders/cart/addToCartPublisher";
import { useAppDispatch } from "@/utils/storage/stores/store";
import { createContext, useState } from "react";

/**Контекст для добавления списка товаров в корзину*/
export const AddProductsListToCartContext = createContext<{
    addProductsListToCart: (cartId: number, itemsId: number[]) => void;
    isLoadingList: boolean;
}>({
    addProductsListToCart: () => { },
    isLoadingList: false,
});

/**
 * Провайдер контекста добавления списка товаров в корзину
 * @param children - дочерние элементы
 * @returns 
 */
export const AddProductsListToCartContextProvider = ({ children }: { children: React.ReactNode }) => {
    const [isLoadingList, setIsLoadingList] = useState(false);
    const dispatch = useAppDispatch();

    /**
     * Добавление списка товаров в корзину
     * @param cartId - id корзины
     * @param itemsId - списко идентификаторов товаров
     */
    const addProductsListTocart = (cartId: number, itemsId: number[]) => {
        setIsLoadingList(true);
        const promises: Promise<any>[] = [];

        itemsId.forEach(itemId => {
            promises.push(dispatch(addToCartPublisher({cartId, itemId, isShowPopup: false})));
        });

        Promise.all(promises).then(() => {
            setIsLoadingList(false);
        });
    };

    return (
        <AddProductsListToCartContext.Provider value={{ addProductsListToCart: addProductsListTocart, isLoadingList }}>
            {children}
        </AddProductsListToCartContext.Provider>
    )
}